import React from 'react';
var Highcharts = require('highcharts');

export default class EnvironmentPosting extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        this.renderChart();
    }

    componentDidUpdate() {
        this.renderChart();
    }

    shadeColor2(color, percent) {
        var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
        return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
    }

    renderChart() {
        let fontSize = this.props.campaignType === 'posting' ? '12px' : '9px';
        Highcharts.chart("environment_container",
            {
                colors: [this.props.color, this.shadeColor2(this.props.color, 0.2), this.shadeColor2(this.props.color, 0.4), this.shadeColor2(this.props.color, 0.6),this.shadeColor2(this.props.color, 0.8)],

                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                title: {
                    text: this.props.dataType,
                    style: { fontSize: 12 }
                },
                tooltip: {
                    enabled: true,
                    style: {
                        fontSize: '12px'
                    },
                    pointFormat: '<span style="color:{point.color}">●</span> Delivered: <b>{point.y}</b><br/>'
                },

                credits: false,

                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.name} {point.y}',
                            style: {
                                fontSize: fontSize,
                                fontWeight: "normal"
                            }
                        }
                    }
                },
                series: [{
                    name: '',
                    enableMouseTracking: true,
                    colorByPoint: true,
                    data: this.props.environment.map((x) => {
                        return {
                            name: x.name,
                            y: x.value
                        }
                    })
                }]
            });
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>Environment</h4>
                </div>
                <div className="col-md-12">
                    <div id="environment_container"></div>
                </div>
            </div>
        );
    }
}